import React from 'react';
import clsx from 'clsx';
import { BadgeDetail } from './BadgeDetail';
import { Icon, Typography } from '@/components/common';
import { StatusCaseItem } from '@/interfaces';
import { EligibleStates } from './EligibleStates';
import { InfoCard } from './InfoCard';
import Icons from '@/const/icons';
import { BackButton } from './BackButton';

interface Props {
	aboutClaim: string | undefined;
	caseStatus: StatusCaseItem | undefined;
	criteria: string;
	previewMode?: boolean;
	statesToList: string;
	statesToModal: (string | undefined)[];
	title: string;
}

export const SummaryCard: React.FC<Props> = ({
	aboutClaim = '',
	caseStatus,
	criteria,
	previewMode,
	statesToList,
	statesToModal,
	title,
}) => {
	return (
		<div className="px-4 lg:px-0 mt-2">
			<BackButton previewMode={previewMode} />
			<div className="flex flex-col-reverse lg:flex-row items-center justify-between relative mt-6 xl:mt-11">
				<div className="w-full">
					<div className={clsx('flex items-center gap-6')}>
						<BadgeDetail status={caseStatus} className="" />
						<EligibleStates
							statesToModal={statesToModal}
							statesToList={statesToList}
						/>
					</div>
					<div className="flex-1 mt-5 xl:mt-4 rounded-3xl lg:rounded-none w-full">
						<Typography
							type="headline-3"
							className="leading-[140%] !mt-0 !text-[30px] lg:!text-6xl"
						>
							{title}
						</Typography>

						<div
							dangerouslySetInnerHTML={{ __html: aboutClaim }}
							className={clsx(
								'leading-[150%] mt-6 xl:mt-4 text-sm lg:text-lg xl:text-gray-35'
							)}
						/>

						<div className="rounded-3xl border border-purple-150/50 bg-purple-150/5 p-6 mt-6 xl:mt-6 max-w-[730px]">
							<div className="flex items-center gap-2">
								<Icon
									src={Icons.tickSquare}
									className="!text-black"
									width={24}
									height={24}
								/>
								<Typography type="semibold-20">Who can join?</Typography>
							</div>
							<div
								dangerouslySetInnerHTML={{ __html: criteria }}
								className={clsx('text-black opacity-60 mt-4 leading-[180%]')}
							/>
						</div>
						<div
							className={clsx(
								'flex flex-col lg:flex-row lg:items-center lg:gap-16 xl:mt-8'
							)}
						>
							<InfoCard
								title="Law Firm"
								name="Lowey Dannenberg, P.C."
								image={Icons.logoLowey}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
